<div class="spinner-container">
    <ix-spinner *ngIf="showSpinner; else valueTemplate" class="spinner"></ix-spinner>
    <ng-template #valueTemplate>
        <span class="spinner-value">{{ customValue }}</span>
    </ng-template>
</div>